class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
    if (window.Rebuy) {
      Rebuy.init();
    }
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }

        })
        .catch((e) => {
          console.error(e);
        });
      if (window.Rebuy) {
        Rebuy.init();
      }
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'tex`xt/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });

    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );

          if (window.Rebuy && typeof Rebuy.reinit === 'function') {
            Rebuy.reinit();
          }
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        setTimeout(() => {
          const shippingZoneInput = document.querySelector('#ShippingZone');
          const shippingZoneValue = shippingZoneInput ? shippingZoneInput.value : '';
          const newshippingZoneInput = document.querySelector('#NewShippingZone');
          const newshippingZoneValue = newshippingZoneInput ? newshippingZoneInput.value : '';
          const defaultZoneInput = document.querySelector('#cartZipCodeHidden');
          const defaultZoneValue = defaultZoneInput ? defaultZoneInput.value : '';

          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {

              const quantityInput = document.querySelector(".product-form__buttons .quantity__input");
              if (quantityInput) {
                const maxAllowed = parseInt(quantityInput.getAttribute("data-max-allowed"));
                const variantId = document.querySelector(".product-variant-id")?.value; // identify current product/variant          
                if (maxAllowed > 0 && variantId) {
                  let totalMilkQty = 0;

                  cart.items.forEach((item) => {
                    if (item.id == variantId) {
                      if (item.product_type && (item.product_type.includes("Milk") || item.product_type.includes("milk"))) {
                        totalMilkQty += item.quantity;
                      }
                    }
                  });

                  // ✅ Remaining qty available
                  let remaining = maxAllowed - totalMilkQty;
                  if (remaining < 0) remaining = 0;
                  quantityInput.setAttribute("data-max", remaining);
                  quantityInput.setAttribute("max", remaining);

                  const addToCartBtn = document.querySelector(".product-form__submit");
                  if (addToCartBtn) {
                    if (totalMilkQty >= maxAllowed) {
                      addToCartBtn.setAttribute("disabled", "disabled");
                      addToCartBtn.classList.add("disabled");

                      let errorBlock = document.querySelector(".product-form .milk-qty-error");
                      if (errorBlock) errorBlock.style.display = "block";
                    } else {
                      addToCartBtn.removeAttribute("disabled");
                      addToCartBtn.classList.remove("disabled");

                      let errorBlock = document.querySelector(".product-form .milk-qty-error");
                      if (errorBlock) errorBlock.style.display = "none";
                    }
                  }
                }
              }
              document.querySelectorAll(".card__content").forEach((form) => {
                const quantityInput = form.querySelector(".quantity__input");
                const addToCartBtn = form.querySelector(".quick-add__submit");
                const variantInput = form.querySelector(".product-variant-id");

                if (!quantityInput || !variantInput) return;

                const maxAllowed = parseInt(quantityInput.getAttribute("data-max-allowed"));
                const variantId = variantInput.value;

                if (maxAllowed > 0 && variantId) {
                  fetch("/cart.js")
                    .then((res) => res.json())
                    .then((cart) => {
                      let currentProductQty = 0;

                      cart.items.forEach((item) => {
                        if (item.id == parseInt(variantId)) {
                          if (item.product_type && (item.product_type.includes("Milk") || item.product_type.includes("milk"))) {
                            currentProductQty += item.quantity;
                          }
                        }
                      });

                      let remaining = maxAllowed - currentProductQty;
                      if (remaining < 0) remaining = 0;

                      quantityInput.setAttribute("data-max", remaining);
                      quantityInput.setAttribute("max", remaining);

                      if (addToCartBtn) {
                        if (currentProductQty >= maxAllowed) {
                          addToCartBtn.setAttribute("disabled", "disabled");
                          addToCartBtn.classList.add("disabled");
                        } else {
                          addToCartBtn.removeAttribute("disabled");
                          addToCartBtn.classList.remove("disabled");
                        }
                      }
                    });
                }
              });

              let needsDryIce = cart.items.some(item =>
                item.sku && item.sku.length >= 11 && item.sku[10] === '3'
              );

              const newAttributes = {
                "Dry Ice Order": needsDryIce ? "Dry Ice" : "",
                "Shipping Zone": shippingZoneValue || "",
                "Zone": newshippingZoneValue || "",
                "Default address zip": defaultZoneValue || ""
              };

              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: newAttributes })
              });
            });

        }, 10);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

const buttons = document.querySelectorAll('.quick-add__submit');
buttons.forEach(button => {
  button.addEventListener('click', () => {
    setTimeout(() => {
      if (window.Rebuy && typeof Rebuy.init === 'function') {
        Rebuy.init();
      }
    }, 500);
  });
});


// ✅ Checkbox toggle
document.addEventListener('change', function (e) {
  const checkbox = e.target.closest('#shipping-policy');
  if (checkbox) {
    const checkoutButton = document.querySelector('.cart__checkout-button');
    if (checkoutButton) {
      const isChecked = checkbox.checked;
      checkoutButton.disabled = !isChecked;
      checkoutButton.classList.toggle('disabled', !isChecked);
    }
  }
});

// ✅ Initial checkbox state
const initCheckbox = document.getElementById('shipping-policy');
const initButton = document.querySelector('.cart__checkout-button');
if (initCheckbox && initButton) {
  initButton.disabled = !initCheckbox.checked;
  initButton.classList.toggle('disabled', !initCheckbox.checked);
}

// ✅ Delegated click handling
document.addEventListener('click', function (event) {
  const optionBox = event.target.closest('.block__cart-drawer-selling-option-box');
  if (optionBox) {
    event.preventDefault();
    const ul = optionBox.querySelector('ul');
    if (ul) {
      ul.style.display = (ul.style.display === 'none' || ul.style.display === '') ? 'block' : 'none';
    }
  }

  // Plan selection
  const selectedItem = event.target.closest('.block__cart-drawer-selling-option-box ul li');
  if (selectedItem) {
    const ul = selectedItem.closest('ul');
    if (!ul) return;

    ul.querySelectorAll('li').forEach(item => item.classList.remove('active'));
    selectedItem.classList.add('active');

    const selectedText = selectedItem.textContent;
    const displayParagraph = selectedItem.closest('.block__cart-drawer-selling-option-box')?.querySelector('p');
    if (displayParagraph) displayParagraph.innerHTML = selectedText;

    const cartItemSellingPlanID = selectedItem.getAttribute('data-value');
    const cartItem = selectedItem.closest('.cart-item');
    if (!cartItem) return;

    const cartItemIndex = cartItem.getAttribute('item-data-index');
    const quantityInput = cartItem.querySelector('.quantity__input');
    const cartItemQty = quantityInput ? quantityInput.value : 1;

    updateSellingPlan(cartItemSellingPlanID, cartItemIndex, cartItemQty);
  }

  // Toggle subscribe
  const toggleButton = event.target.closest('.block__cart-drawer-selling-plan-toggle');
  if (toggleButton) {
    event.preventDefault();
    toggleButton.classList.toggle("subscribe");

    const cartItem = toggleButton.closest('.cart-item');
    if (!cartItem) return;

    const cartItemIndex = cartItem.getAttribute("item-data-index");
    const quantityInput = cartItem.querySelector('.quantity__input');
    const cartItemQty = quantityInput ? quantityInput.value : 1;

    let cartItemSellingPlanID = '';
    const planBox = cartItem.querySelector('.block__cart-drawer-selling-option-box');

    if (toggleButton.classList.contains("subscribe")) {
      const activeItem = planBox?.querySelector('li.active') || planBox?.querySelector('li:first-child');
      if (activeItem) {
        cartItemSellingPlanID = activeItem.getAttribute("data-value");
      }
    }

    updateSellingPlan(cartItemSellingPlanID, cartItemIndex, cartItemQty);

    // ✅ Wait 2 seconds, then refresh the cart drawer via AJAX
    setTimeout(() => {
      if (typeof updateCart === 'function') {
        updateCart();
      } else {
        console.warn('⚠️ updateCart() is not defined.');
      }
    }, 2000);
  }
});

// ✅ Selling plan updater
function updateSellingPlan(cartItemSellingPlanID, cartItemIndex, cartItemQty) {
  if (!cartItemIndex || isNaN(parseInt(cartItemQty))) {
    console.error("❌ Missing cart item index or quantity", { cartItemIndex, cartItemQty });
    return;
  }

  const formData = {
    line: parseInt(cartItemIndex),
    quantity: parseInt(cartItemQty),
    selling_plan: cartItemSellingPlanID || null,
  };

  fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => response.json())
    .then(data => {
    })
    .catch(error => {
      console.error('❌ Error updating selling plan:', error);
    });
}

// ✅ updateCart() function – Re-renders cart drawer using section
function updateCart() {
  fetch('/?sections=cart-drawer')
    .then(response => response.json())
    .then(data => {
      const parser = new DOMParser();
      const html = parser.parseFromString(data['cart-drawer'], 'text/html');
      const newDrawer = html.querySelector('.cart__drawer');

      if (newDrawer) {
        document.querySelector('.cart__drawer').innerHTML = newDrawer.innerHTML;
      } else {
        console.warn('⚠️ Could not find .cart__drawer in fetched content.');
      }
    })
    .catch(error => {
      console.error('❌ Error loading cart drawer section:', error);
    });
}

//checkout blocks when the item order total less than $50 
if (window.customerTags && window.customerTags.includes('Signed PMA Form')) {
  const body = document.querySelector('body');
  const MINIMUM_TOTAL = body?.dataset.minimumOrder
    ? parseFloat(body.dataset.minimumOrder)
    : 50.00;
  document.addEventListener('click', async function (event) {
    const target = event.target.closest('#CartDrawer-Checkout');
    if (!target) return;
    event.preventDefault();

    const metaMapScript = document.getElementById('product-meta-map');
    if (!metaMapScript) {
      window.location.href = '/checkout';
      return;
    }
    const productMetaMap = JSON.parse(metaMapScript.textContent.trim());
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      let validTotal = 0;
      let hasOnlyBoxAndPMA = true;

      cart.items.forEach(item => {
        const meta = productMetaMap[item.key] || {};
        const isDedicatedBox = meta.packing_variant === 'Dedicated Box';
        const title = item.title.trim().toLowerCase();
        const isPMA = title === 'private membership agreement (pma)';
        const isSavedBy = title.includes('savedby');
        const isGiftCard = title.includes('gift card');
        const isAllowed = isDedicatedBox || isPMA || isSavedBy || isGiftCard;
        if (!isAllowed) {
          hasOnlyBoxAndPMA = false;
          validTotal += item.line_price / 100;
        }
      });
      if (hasOnlyBoxAndPMA || validTotal >= MINIMUM_TOTAL || window.customerTags.includes('localpickup')) {
        window.location.href = '/checkout';
      } else {
        alert(
          `Your cart is below the $${MINIMUM_TOTAL} minimum for individually shipped items. ` +
          `To continue, please add more items not included in a subscription or dedicated box.`
        );
      }
    } catch (err) {
      console.error("Cart check failed:", err);
      window.location.href = '/checkout';
    }
  });
}